module.exports = __webpack_public_path__ + "img/logo__ekyzmat-full--light.cdaea3a8.svg";